<template>
  <div class="news">
    <div style="text-align: right; margin-bottom: 10px;">
      <el-button type="primary" @click="handleCreateOrModify()">修改</el-button>
    </div>
    <editor v-model="content" height="1300px" :border="true" />
  </div>
</template>

<script>

import Editor from "../../components/Editor";
export default {
  components: {
    Editor, // 注册组件
  },
  data() {
    return {
      content: "",
      loading: true
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.http
        .get("/basic/invite")
        .then(response => {
          // window.console.log(response);
          this.content = this.convertEditorContent(response.data);
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
          this.$message({
            message: "网络或程序异常！" + e,
            type: "error"
          });
        });
    },
    handleCreateOrModify() {
      this.$confirm("确定要修改吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {};
          params = this.reverseConvertEditorContent(this.content);
          this.loading = true;
          this.http
            .put(`/basic/invite`, params, this.options)
            .then(response => {
              this.loading = false;
              // window.console.log(response);
              this.$message({
                message: "修改成功！",
                type: "success"
              });
              this.dialogFormVisible = false;
              this.loadData();
            })
            .catch(e => {
              this.loading = false;
              this.$message({
                message: e,
                type: "error"
              });
            });
        }) .catch(() => {
        });
    },
  }
};
</script>

<style lang="scss" scoped>
.news {
  margin: 0 5%;
}
</style>